import { gql } from '@grandvisionhq/graphql';

var StoreAppointmentTypesFragment = gql`
  fragment StoreAppointmentTypes on Store {
    appointmentTypes {
      isAvailableInStore
      id
    }
  }
`;

export { StoreAppointmentTypesFragment as default };
//# sourceMappingURL=store-appointment-types.js.map
